import React from "react";

const Header = ({ text }) => {
  return (
    <header className="header">
      <div className="side_line"></div>
      <h3>{text}</h3>
    </header>
  );
};

export default Header;
